export default __webpack_public_path__ + "static/media/email.b231785e.svg";